"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "selectObject", {
    enumerable: true,
    get: function() {
        return selectObject;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("../genRollupSelectv2"));
const _models = require("~/models");
const _dbHelpers = require("~/helpers/dbHelpers");
const _sqlSanitize = require("~/helpers/sqlSanitize");
const _constants = require("~/constants");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const selectObject = (baseModel, logger)=>{
    return async ({ qb, columns: _columns, fields: _fields, extractPkAndPv, viewId, fieldsSet, alias, validateFormula, pkAndPvOnly = false, linksAsLtar = false })=>{
        // keep a common object for all columns to share across all columns
        const aliasToColumnBuilder = {};
        let viewOrTableColumns;
        const res = {};
        let view;
        let fields;
        if (fieldsSet == null ? void 0 : fieldsSet.size) {
            viewOrTableColumns = _columns || await baseModel.model.getColumns(baseModel.context);
        } else {
            view = await _models.View.get(baseModel.context, viewId);
            const viewColumns = viewId && await _models.View.getColumns(baseModel.context, viewId);
            fields = Array.isArray(_fields) ? _fields : _fields == null ? void 0 : _fields.split(',');
            // const columns = _columns ?? (await baseModel.model.getColumns(baseModel.context));
            // for (const column of columns) {
            viewOrTableColumns = viewColumns || _columns || await baseModel.model.getColumns(baseModel.context);
        }
        for (const viewOrTableColumn of viewOrTableColumns){
            var _viewOrTableColumn_fk_column_id;
            const column = viewOrTableColumn instanceof _models.Column ? viewOrTableColumn : await _models.Column.get(baseModel.context, {
                colId: (_viewOrTableColumn_fk_column_id = viewOrTableColumn.fk_column_id) != null ? _viewOrTableColumn_fk_column_id : viewOrTableColumn.id
            });
            if (!column) {
                logger.warn(`Column not found for viewOrTableColumn: ${JSON.stringify(viewOrTableColumn)}`);
                continue;
            }
            // hide if column marked as hidden in view
            // of if column is system field and system field is hidden
            if ((0, _dbHelpers.shouldSkipField)(fieldsSet, viewOrTableColumn, view, column, extractPkAndPv || pkAndPvOnly, pkAndPvOnly)) {
                continue;
            }
            if (!(0, _dbHelpers.checkColumnRequired)(column, fields, extractPkAndPv)) continue;
            switch(column.uidt){
                case _nocodbsdk.UITypes.CreatedTime:
                case _nocodbsdk.UITypes.LastModifiedTime:
                case _nocodbsdk.UITypes.DateTime:
                    {
                        const columnName = await (0, _dbHelpers.getColumnName)(baseModel.context, column, _columns || await baseModel.model.getColumns(baseModel.context));
                        if (baseModel.isMySQL) {
                            // MySQL stores timestamp in UTC but display in timezone
                            // To verify the timezone, run `SELECT @@global.time_zone, @@session.time_zone;`
                            // If it's SYSTEM, then the timezone is read from the configuration file
                            // if a timezone is set in a DB, the retrieved value would be converted to the corresponding timezone
                            // for example, let's say the global timezone is +08:00 in DB
                            // the value 2023-01-01 10:00:00 (UTC) would display as 2023-01-01 18:00:00 (UTC+8)
                            // our existing logic is based on UTC, during the query, we need to take the UTC value
                            // hence, we use CONVERT_TZ to convert back to UTC value
                            res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || columnName)] = baseModel.dbDriver.raw(`CONVERT_TZ(??, @@GLOBAL.time_zone, '+00:00')`, [
                                `${(0, _sqlSanitize.sanitize)(alias || baseModel.tnPath)}.${columnName}`
                            ]);
                            break;
                        } else if (baseModel.isPg) {
                            // if there is no timezone info,
                            // convert to database timezone,
                            // then convert to UTC
                            if (column.dt !== 'timestamp with time zone' && column.dt !== 'timestamptz') {
                                res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || columnName)] = baseModel.dbDriver.raw(`?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'`, [
                                    `${(0, _sqlSanitize.sanitize)(alias || baseModel.tnPath)}.${columnName}`
                                ]).wrap('(', ')');
                                break;
                            }
                        }
                        res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || columnName)] = (0, _sqlSanitize.sanitize)(`${alias || baseModel.tnPath}.${columnName}`);
                    }
                    break;
                case _nocodbsdk.UITypes.LinkToAnotherRecord:
                case _nocodbsdk.UITypes.Lookup:
                    break;
                case _nocodbsdk.UITypes.QrCode:
                    {
                        const qrCodeColumn = await column.getColOptions(baseModel.context);
                        if (!qrCodeColumn.fk_qr_value_column_id) {
                            qb.select(baseModel.dbDriver.raw(`? as ??`, [
                                'ERR!',
                                (0, _dbHelpers.getAs)(column)
                            ]));
                            break;
                        }
                        const qrValueColumn = await _models.Column.get(baseModel.context, {
                            colId: qrCodeColumn.fk_qr_value_column_id
                        });
                        // If the referenced value cannot be found: cancel current iteration
                        if (qrValueColumn == null) {
                            break;
                        }
                        switch(qrValueColumn.uidt){
                            case _nocodbsdk.UITypes.Formula:
                                try {
                                    const selectQb = await baseModel.getSelectQueryBuilderForFormula(qrValueColumn, alias, validateFormula, aliasToColumnBuilder);
                                    qb.select({
                                        [column.column_name]: selectQb.builder
                                    });
                                } catch (unused) {
                                    continue;
                                }
                                break;
                            default:
                                {
                                    qb.select({
                                        [column.column_name]: qrValueColumn.column_name
                                    });
                                    break;
                                }
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.Barcode:
                    {
                        const barcodeColumn = await column.getColOptions(baseModel.context);
                        if (!barcodeColumn.fk_barcode_value_column_id) {
                            qb.select(baseModel.dbDriver.raw(`? as ??`, [
                                'ERR!',
                                (0, _dbHelpers.getAs)(column)
                            ]));
                            break;
                        }
                        const barcodeValueColumn = await _models.Column.get(baseModel.context, {
                            colId: barcodeColumn.fk_barcode_value_column_id
                        });
                        // If the referenced value cannot be found: cancel current iteration
                        if (barcodeValueColumn == null) {
                            break;
                        }
                        switch(barcodeValueColumn.uidt){
                            case _nocodbsdk.UITypes.Formula:
                                try {
                                    const selectQb = await baseModel.getSelectQueryBuilderForFormula(barcodeValueColumn, alias, validateFormula, aliasToColumnBuilder);
                                    qb.select({
                                        [(0, _dbHelpers.getAs)(column)]: selectQb.builder
                                    });
                                } catch (unused) {
                                    continue;
                                }
                                break;
                            default:
                                {
                                    qb.select({
                                        [(0, _dbHelpers.getAs)(column)]: barcodeValueColumn.column_name
                                    });
                                    break;
                                }
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.Formula:
                    {
                        try {
                            const selectQb = await baseModel.getSelectQueryBuilderForFormula(column, alias, validateFormula, aliasToColumnBuilder);
                            if ('toQuery' in selectQb.builder) {
                                const selectQbQuery = selectQb.builder.toQuery();
                                qb.select(baseModel.dbDriver.raw(`${selectQbQuery.replaceAll('?', '\\?')} as ??`, [
                                    (0, _dbHelpers.getAs)(column)
                                ]));
                            } else {
                                qb.select(baseModel.dbDriver.raw(`?? as ??`, [
                                    selectQb.builder,
                                    (0, _dbHelpers.getAs)(column)
                                ]));
                            }
                        } catch (e) {
                            logger.log(e);
                            // return dummy select
                            qb.select(baseModel.dbDriver.raw(`'ERR' as ??`, [
                                (0, _dbHelpers.getAs)(column)
                            ]));
                        }
                    }
                    break;
                case _nocodbsdk.UITypes.Button:
                    {
                        try {
                            const colOption = column.colOptions;
                            if (colOption.type === _nocodbsdk.ButtonActionsType.Url) {
                                const selectQb = await baseModel.getSelectQueryBuilderForFormula(column, alias, validateFormula, aliasToColumnBuilder);
                                switch(baseModel.dbDriver.client.config.client){
                                    case 'mysql2':
                                        qb.select(baseModel.dbDriver.raw(`JSON_OBJECT('type', ? , 'label', ?, 'url', ??) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            selectQb.builder,
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    case 'pg':
                                        qb.select(baseModel.dbDriver.raw(`json_build_object('type', ? ,'label', ?, 'url', ??) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            selectQb.builder,
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    case 'sqlite3':
                                        qb.select(baseModel.dbDriver.raw(`json_object('type', ?, 'label', ?, 'url', ??) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            selectQb.builder,
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    default:
                                        qb.select(baseModel.dbDriver.raw(`'ERR' as ??`, [
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                }
                            } else if ([
                                _nocodbsdk.ButtonActionsType.Webhook,
                                _nocodbsdk.ButtonActionsType.Script
                            ].includes(colOption.type)) {
                                const key = colOption.type === _nocodbsdk.ButtonActionsType.Webhook ? 'fk_webhook_id' : 'fk_script_id';
                                switch(baseModel.dbDriver.client.config.client){
                                    case 'mysql2':
                                        qb.select(baseModel.dbDriver.raw(`JSON_OBJECT('type', ?, 'label', ?, '${key}', ?) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            colOption[key],
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    case 'pg':
                                        qb.select(baseModel.dbDriver.raw(`json_build_object('type', ?, 'label', ?, '${key}', ?) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            colOption[key],
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    case 'sqlite3':
                                        qb.select(baseModel.dbDriver.raw(`json_object('type', ?, 'label', ?, '${key}', ?) as ??`, [
                                            colOption.type,
                                            `${colOption.label}`,
                                            colOption[key],
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                        break;
                                    default:
                                        qb.select(baseModel.dbDriver.raw(`'ERR' as ??`, [
                                            (0, _dbHelpers.getAs)(column)
                                        ]));
                                }
                            }
                        } catch (e) {
                            logger.log(e);
                            // return dummy select
                            qb.select(baseModel.dbDriver.raw(`'ERR' as ??`, [
                                (0, _dbHelpers.getAs)(column)
                            ]));
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.Rollup:
                case _nocodbsdk.UITypes.Links:
                    if (column.uidt === _nocodbsdk.UITypes.Links && linksAsLtar) {
                        break;
                    }
                    qb.select((await (0, _genRollupSelectv2.default)({
                        baseModelSqlv2: baseModel,
                        // tn: baseModel.title,
                        knex: baseModel.dbDriver,
                        // column,
                        alias,
                        columnOptions: await column.getColOptions(baseModel.context)
                    })).builder.as((0, _dbHelpers.getAs)(column)));
                    break;
                case _nocodbsdk.UITypes.CreatedBy:
                case _nocodbsdk.UITypes.LastModifiedBy:
                    {
                        const columnName = await (0, _dbHelpers.getColumnName)(baseModel.context, column, _columns || await baseModel.model.getColumns(baseModel.context));
                        res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || columnName)] = (0, _sqlSanitize.sanitize)(`${alias || baseModel.tnPath}.${columnName}`);
                        break;
                    }
                case _nocodbsdk.UITypes.SingleSelect:
                    {
                        res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`COALESCE(NULLIF(??, ''), NULL)`, [
                            (0, _sqlSanitize.sanitize)(column.column_name)
                        ]);
                        break;
                    }
                case _nocodbsdk.UITypes.LongText:
                    {
                        if (baseModel.dbDriver.isExternal) {
                            const colPath = (0, _sqlSanitize.sanitize)(`${alias || baseModel.tnPath}.${column.column_name}`);
                            if (baseModel.isPg) {
                                res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`SUBSTR(??::TEXT, 1, ?)`, [
                                    colPath,
                                    _constants.NC_MAX_TEXT_LENGTH
                                ]);
                            } else if (baseModel.isMySQL) {
                                res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`SUBSTR(??, 1, ?)`, [
                                    colPath,
                                    _constants.NC_MAX_TEXT_LENGTH
                                ]);
                            } else if (baseModel.isSqlite) {
                                res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`SUBSTR(??, 1, ?)`, [
                                    colPath,
                                    _constants.NC_MAX_TEXT_LENGTH
                                ]);
                            } else {
                                // SQL Server / other databases - use LEFT function
                                res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`LEFT(??, ?)`, [
                                    colPath,
                                    _constants.NC_MAX_TEXT_LENGTH
                                ]);
                            }
                            break;
                        }
                    // Else fall through
                    }
                default:
                    if (baseModel.isPg) {
                        if (column.dt === 'bytea') {
                            var _column_meta;
                            res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = baseModel.dbDriver.raw(`encode(??.??, '${((_column_meta = column.meta) == null ? void 0 : _column_meta.format) === 'hex' ? 'hex' : 'escape'}')`, [
                                alias || baseModel.model.table_name,
                                column.column_name
                            ]);
                            break;
                        }
                    }
                    res[(0, _sqlSanitize.sanitize)((0, _dbHelpers.getAs)(column) || column.column_name)] = (0, _sqlSanitize.sanitize)(`${alias || baseModel.tnPath}.${column.column_name}`);
                    break;
            }
        }
        qb.select(res);
    };
};
